import * as THREE from "three";
import type { RayHit } from "../engine/raycast";

export class BlockHighlight {
  readonly mesh: THREE.LineSegments;
  private geo: THREE.EdgesGeometry;

  constructor() {
    this.geo = new THREE.EdgesGeometry(new THREE.BoxGeometry(1.002, 1.002, 1.002));
    this.mesh = new THREE.LineSegments(
      this.geo,
      new THREE.LineBasicMaterial({ color: 0x1c1812, transparent: true, opacity: 0.7 }),
    );
    this.mesh.visible = false;
    this.mesh.renderOrder = 4;
  }

  set(hit: RayHit | null): void {
    if (!hit) {
      this.mesh.visible = false;
      return;
    }
    this.mesh.visible = true;
    this.mesh.position.set(hit.x + 0.5, hit.y + 0.5, hit.z + 0.5);
  }
}

export class BreakCrack {
  readonly mesh: THREE.Mesh;
  private mat: THREE.MeshBasicMaterial;

  constructor() {
    this.mat = new THREE.MeshBasicMaterial({
      color: 0x1a1612,
      transparent: true,
      opacity: 0,
      depthWrite: false,
    });
    this.mesh = new THREE.Mesh(new THREE.BoxGeometry(1.01, 1.01, 1.01), this.mat);
    this.mesh.visible = false;
  }

  set(hit: RayHit | null, progress: number): void {
    if (!hit || progress <= 0) {
      this.mesh.visible = false;
      return;
    }
    this.mesh.visible = true;
    this.mesh.position.set(hit.x + 0.5, hit.y + 0.5, hit.z + 0.5);
    this.mat.opacity = 0.12 + progress * 0.35;
  }
}
